import React, { Component } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@material-ui/core";
import { connect } from "react-redux";

class OrderDetailDialogImage extends Component {
  // -------------------------- STATE --------------------------
  constructor() {
    super();
    this.state = {};
  }
  // -------------------------- FUNCTIONS --------------------------

  // -------------------------- FIREBASE FUNCTIONS --------------------------
  s;

  // -------------------------- RENDER --------------------------

  renderDialogHeader = () => {
    return <DialogTitle id="scroll-dialog-title">Photo</DialogTitle>;
  };

  renderDialogBody = () => {
    const { photo } = this.props;
    return (
      <DialogContent dividers>
        <img src={photo} alt="signature" className="order-detail-picture" />
      </DialogContent>
    );
  };

  renderDialogButton = () => {
    return (
      <DialogActions>
        <Button
          variant="outlined"
          className="add-btn"
          color="default"
          style={{ marginRight: 10 }}
          onClick={() => this.props.handleClose()}
        >
          Ok
        </Button>
      </DialogActions>
    );
  };

  // -------------------------- MAIN --------------------------
  render() {
    const { dialogOpen, handleClose } = this.props;
    return (
      <Dialog
        open={dialogOpen}
        onClose={handleClose}
        scroll="paper"
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
        maxWidth="lg"
        fullWidth
      >
        {this.renderDialogHeader()}
        {this.renderDialogBody()}
        {this.renderDialogButton()}
      </Dialog>
    );
  }
}

// const mapStateToProp = (state) => ({});

// const mapDispatchToProps = {};

export default connect(null, null)(OrderDetailDialogImage);
